import { Button, Container, Header, Icon, Input, Popup, Segment } from "semantic-ui-react";
import { FeeTable, getLimitInfoStatue } from "../layout/ui/SinglePage/Other/StatueV2";
import { useState } from "react";


function LimitMebersTournament(value) {

  const [participants, setParticipants] = useState("");
  const [calculatedCost, setCalculatedCost] = useState(null);

  const handleCalculate = () => {
    const num = parseInt(participants, 10);
    if (!isNaN(num) && num > 0) {
      setCalculatedCost(calculateExtraCost(num));
    } else {
      setCalculatedCost(null);
    }
  };

  return (<Container textAlign="center">
    <Header style={{ marginBottom: 30 }} as='h3' icon textAlign="center">
      <Icon name='users' />
      Dlaczego obowiązuje limit {process.env.REACT_APP_IN_LIMITALLMEMBERS} uczestników?

    </Header>
    <p>
      Nasza aplikacja została stworzona z myślą o różnych typach wydarzeń – od małych lokalnych turniejów po duże imprezy sportowe.
      Dla turniejów <strong>powyżej {process.env.REACT_APP_IN_LIMITALLMEMBERS} uczestników (zawodników lub drużyn)</strong> naliczana jest dopłata zgodnie z poniższym zestawieniem:.
    </p>
    {FeeTable()}
    <p>
      Limit {Number(process.env.REACT_APP_IN_LIMITALLMEMBERS)} uczestników dotyczy <strong>łącznej liczby uczestników w wydarzeniu</strong>, które odbywa się np. w tej samej lokalizacji i obejmuje np. jeden dzień a nawet trzy dni (duży turniej weekendowy).
    </p>

    <p>
  Tak duże wydarzenia wiążą się z <strong>większym obciążeniem systemu</strong> – przetwarzaniem danych, ruchem na serwerze i zużyciem zasobów technicznych.
  Dzięki dopłacie możemy <strong>utrzymać wysoką wydajność i niezawodność działania aplikacji</strong>, a także rozwijać ją jako <strong>narzędzie klasy premium</strong>, które <strong>podnosi prestiż Twojego turnieju lub ligi</strong>.
  Otrzymujesz dostęp do <strong>profesjonalnego systemu</strong>, gotowego do działania <strong>na najwyższym poziomie</strong>, co pozytywnie wpływa na <strong>postrzeganie wydarzenia</strong> przez uczestników, widzów i partnerów.
</p>
    

    <Segment style={{backgroundColor:"#ebebeb"}}>
      <p><strong>Oblicz szacunkowy koszt uczestników:</strong></p>
      <Input
        type="number"
        placeholder="Liczba uczestników"
        value={participants}
        onChange={(e) => setParticipants(e.target.value)}
        style={{ marginRight: 10 }}
      />
      <Button primary onClick={handleCalculate}>Oblicz</Button>
      {calculatedCost !== null && (
        <p style={{ marginTop: 10 }}>
          Szacunkowy koszt dopłaty dla {participants} uczestników: <strong>{calculatedCost} zł netto</strong>
        </p>
      )}
    </Segment>

    <p>
      Szczegółowe zasady dotyczące tego limitu znajdziesz w <Popup flowing hoverable trigger={<strong className='cursorPointer tllink'>punkcie 4.2a Regulaminu</strong>} ><div style={{ maxWidth: 500, maxHeight: 300, overflow: "auto" }}>...<br /><br />{getLimitInfoStatue()}<br /><br />...<br /></div></Popup>.
    </p>

    <p>
      Z góry dziękujemy za zrozumienie i uczciwe korzystanie z aplikacji!
    </p>

  </Container>
  )
}
export default LimitMebersTournament;


export const calculateExtraCost = (totalParticipants) => {
  const baseLimit = 200;
  const baseCost = 0;

  const tiers = [
    { limit: 550, rate: 0.80 },
    { limit: 700, rate: 0.70 },
    { limit: 850, rate: 0.60 },
    { limit: 1000, rate: 0.50 },
    { limit: 1150, rate: 0.40 },
    { limit: 1500, rate: 0.30 },
    { limit: 2000, rate: 0.20 },
    { limit: 3000, rate: 0.20 },
    { limit: 4000, rate: 0.20 },
  ];

  if (totalParticipants <= baseLimit) {
    return baseCost;
  }

  let cost = baseCost;
  let remaining = totalParticipants - baseLimit;
  let previousLimit = baseLimit;

  for (let i = 0; i < tiers.length; i++) {
    const { limit, rate } = tiers[i];
    const tierRange = Math.min(limit - previousLimit, remaining);
    if (tierRange > 0) {
      cost += tierRange * rate;
      remaining -= tierRange;
      previousLimit = limit;
    }
    if (remaining <= 0) break;
  }

  return Math.round(cost * 100) / 100; // zaokrąglenie do 2 miejsc
};